<template>
  <table class="tableSimple">
    <template v-for="(row, i) in rows" :key="i">
      <tr v-if="row.td">
        <th v-html="setTh(row)" :class="{ '-smRow': row.smRowLayout }"></th>
        <td v-html="setTd(row)" :class="{ '-smRow': row.smRowLayout }"></td>
      </tr>
    </template>
  </table>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core'

export default defineComponent({
  name: 'tableSimple',

  props: {
    rows: Array
  },

  setup() {
    interface TableItem {
      th: string
      td: string
      thChild?: string
      tdChild?: string
      kana?: string
      sub?: string
      link?: boolean
      mail?: boolean
      tel?: boolean
      smRowLayout?: boolean
    }

    const setTh = (item: TableItem) => {
      let html = item.th

      if (item.thChild) {
        html += '<br><span class="child">' + item.thChild + '</span>'
      }

      return html
    }

    const setTd = (item: TableItem) => {
      let html = ''

      if (item.link === true) {
        html = `<a href="${item.td}" target="_blank">${item.td}</a>`
      } else if (item.mail === true) {
        html = `<a href="mailto:${item.td}">${item.td}</a>`
      } else if (item.tel === true) {
        html = `<a href="tel:${item.td}">${item.td}</a>`
      } else if (item.kana) {
        html = `${item.td}<span class="kana">${item.kana}</span>`
      } else if (item.sub) {
        html = `${item.td}<span class="sub">${item.sub}</span>`
      } else {
        html = item.td.replace(/\r?\n/g, '<br>')
      }

      if (item.tdChild) {
        html += '<br>' + item.tdChild
      }

      return html
    }

    return {
      setTh,
      setTd
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.tableSimple {
  font-size: 1.4rem;
  line-height: 1.6;

  @include mixins.mediaMax() {
    margin-bottom: -10px;
  }

  th {
    font-weight: 500;
    white-space: nowrap;
    text-align: left;

    @include mixins.mediaMax() {
      display: block;
    }

    @include mixins.media() {
      vertical-align: top;
      padding: 5px 50px 5px 0;
    }
  }

  td {
    padding: 0 0 10px;
    white-space: pre-line;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  td:not(.-smRow) {
    padding: 5px 0;

    @include mixins.mediaMax() {
      display: block;
      margin-bottom: 10px;
    }
  }

  th.-smRow,
  td.-smRow {
    line-height: 1.7;
    @include mixins.media() {
      line-height: 2.1;
      padding-top: 5px;
      padding-bottom: 0;
    }
  }
}

::v-deep {
  a {
    color: var.$color-main;
  }

  .kana {
    display: block;
    font-size: 1.1rem;
    margin-top: 5px;
  }

  .sub {
    display: block;
    font-size: 1.2rem;
    margin-top: 5px;
  }

  .bold {
    display: block;
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 5px;
    &:not(:first-child) {
      margin-top: 10px;
    }
  }

  .child {
    padding-left: 15px;
  }
}
</style>
